/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import flatMap from 'lodash/flatMap';
import get from 'lodash/get';
import { PREFIX } from '../constants';
import { FETCH_AVAILABILITY, RESET_AVAILABILITY } from '../constants/actions';
import {
    asyncDefaults,
    makeAsyncReducer,
    makeAsyncResetReducer,
    mergeReducers,
} from '../utils/async_utils';

const INITIAL_STATE: any = [];

const fetchAvailability = makeAsyncReducer(FETCH_AVAILABILITY);
const resetAvailability = makeAsyncResetReducer(RESET_AVAILABILITY, {});

const availability = mergeReducers(
    asyncDefaults(INITIAL_STATE),
    PREFIX,
    fetchAvailability,
    resetAvailability
);

export default availability;

export const selectors = {
    getAvailability: (state: any) => state.treePermit?.availability?.data,
    getDates: (state: any) =>
        flatMap(state.treePermit.availability.data, (d) => d.start_date.split(';')),
    getAvailabilityStartDate: (state: any) => (cuttingType: string) =>
        get(
            state.treePermit.availability.data.find(
                ({ permit_type }: { permit_type: string }) => permit_type === cuttingType
            ),
            'start_date',
            ''
        ),
};
